/**
 * Entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Page extends BaseModel {
    defaults() {
        return {
            id: null,
            title: null,
            description: null,
            page_type: null,
            display_order: null,
            slug: null,
            display_in_navigation: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            display_order: Number,
            display_in_navigation: Boolean,
        };
    }

    entityName() {
        return 'Page';
    }
}

export class PageCollection extends BaseCollection {
    options() {
        return {
            model: Page,
        };
    }

    entityName() {
        return 'Page';
    }
}
